export default __webpack_public_path__ + "static/media/home-search-realestate.aeaf3862.jpg";